import { Stethoscope, Certificate, ShieldCheck, Globe } from "@phosphor-icons/react";

const ITEMS = [
  { icon: Stethoscope, label: "Physician Led" },
  { icon: Certificate, label: "Patent-Pending Technology" },
  { icon: ShieldCheck, label: "Secure Data" },
  { icon: Globe, label: "Nationwide Telemedicine" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="border-b border-border bg-card/60"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {ITEMS.map(({ icon: Icon, label }) => (
          <div
            key={label}
            data-testid={`trust-item-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex items-center justify-center gap-3"
          >
            <Icon size={22} weight="duotone" className="text-accent flex-shrink-0" />
            <span className="font-mono text-[0.62rem] md:text-[0.68rem] uppercase tracking-[0.18em] text-primary font-semibold">
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
